import request from "@/utils/request";

// 获取
export function getForm() {
  return request({
    url: "/api/officialWebsite/get",
    method: "get",
  });
}